module.exports = __webpack_public_path__ + "static/img/left-bottom-row-6.39fad90d.png";